var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/SendButton/SendButton.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<button class=\"SendButton\" type=\"button\">\n    <span>Отправить</span><img\n        class=\"SendButton-loader\" src=\"";
output += runtime.suppressValue((lineno = 2, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/loader-fast.gif"])), env.opts.autoescape);
output += "\" alt=\"\"><span class=\"SendButton-success\">Отправлено <i\n        class=\"SendButton-checkmark\"></i></span><span class=\"SendButton-repeat\">Повторите</span>\n</button>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/SendButton/SendButton.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SendButton/SendButton.jinja
// module id = 11
// module chunks = 0